module.exports = __webpack_public_path__ + "static/media/SWSCRC6-23.99c714b3.mp3";